// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RegistryApi } from '@digitalasset/utility-operator-api-ts-client';
import React, { useContext } from 'react';

export const UtilityRegistryApiContext = React.createContext<RegistryApi | undefined>(undefined);

export const useUtilityRegistryApiClient: () => RegistryApi = () => {
  const client = useContext<RegistryApi | undefined>(UtilityRegistryApiContext);
  if (!client) {
    throw new Error('Utility registry client not initialized');
  }
  return client;
};
